import styled from 'styled-components'

import { Button, TypeStyle, fromLg } from '@syconium/little-miss-figgy'

export const Container = styled.section`
  background-color: ${o => o.theme.color.fill.subtle};
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  padding: ${o => o.theme.spacing(12, 4)};
  gap: ${o => o.theme.spacing(4)};

  ${fromLg} {
    gap: 0;
    background: unset;
    flex-direction: row;
    padding: ${o => o.theme.spacing(0, 10, 24, 10)};
  }
`

export const MyBag = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;

  ${fromLg} {
    margin-bottom: 0;
    flex-direction: column;
    justify-content: center;
    align-items: start;
  }
`

export const BagTitle = styled(TypeStyle.HeadlineExtraSmall).attrs({ asTag: 'span' })``

export const TotalItems = styled(TypeStyle.BodyMicro).attrs({ asTag: 'span' })`
  color: ${o => o.theme.color.stroke.neutral.text.tertiary.on.background};
  text-transform: lowercase;
`

export const BagCategories = styled.ul`
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  gap: ${o => o.theme.spacing(4)};

  ${fromLg} {
    flex-direction: row;
  }
`

export const CategoryItem = styled.li`
  display: flex;
  align-items: center;
  gap: ${o => o.theme.spacing(2)};
`

export const QuantityNameWrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1 0 0;
`

export const CategoryName = styled(TypeStyle.BodyLarge).attrs({ asTag: 'span' })`
  font-weight: ${o => o.theme.typography.font.weight[700]};
  line-height: 21px;
  white-space: pre;
`

export const CategoryQuantity = styled(TypeStyle.BodyMicro).attrs({ asTag: 'span' })``

export const TotalPriceSection = styled(TypeStyle.HeadlineExtraSmall).attrs({ asTag: 'span' })`
  display: flex;
  justify-content: center;
  text-align: right;
  ${fromLg} {
    padding-left: ${o => o.theme.spacing(4)};
  }
`

export const StyledButton = styled(Button)`
  padding: ${o => o.theme.spacing(4, 16)};
`

export const BottomContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${o => o.theme.spacing(4)};

  ${fromLg} {
    flex-direction: row;
    align-items: baseline;
  }
`
